import KEYS from '@/values/keys';

export const MEETINGS_STORE_NAME = 'MeetingsStore';
export const ALL_SET = 'All';

export const MEETING_EVENTS = {
  GET_MEETING_MEMBERS: 'GET_MEETING_MEMBERS',
  ALL_USER_MESSAGES: 'ALL_USER_MESSAGES',
  RESPONSE_EVENT: 'RESPONSE_EVENT',
  CHANGE_MEETING_SHORT_MENU: 'CHANGE_MEETING_SHORT_MENU',
  UPDATE_DOCUMENT_URL: 'UPDATE_DOCUMENT_URL',
  CHANGE_MEETING_TOGGLE: 'CHANGE_MEETING_TOGGLE',
  RESIZE_WHITEBOARD_TRANSPARENCY: 'RESIZE_WHITEBOARD_TRANSPARENCY',
  SCROLL_WHITEBOARD_TRANSPARENCY: 'SCROLL_WHITEBOARD_TRANSPARENCY',
  SET_READ_ONLY_STUDENT: 'SET_READ_ONLY_STUDENT',
  CHANGE_SPLIT_TAB: 'CHANGE_SPLIT_TAB'
}

export enum WAITING_ROOM_TEXT {
  NOT_READY = 'waitingRoomNotReady',
  READY = 'waitingRoomReady'
}

export enum MEETING_BASE_TYPES {
  FREE = 'FREE',
  DEFAULT = 'DEFAULT_FOR_CLASS'
}

export enum GROUP_TYPES {
  DEFAULT_GROUP1 = 'DEFAULT_FOR_CLASS',
  DEFAULT_GROUP2 = 'DEFAULT_FOR_STUDENT',
  MANUAL_GROUP = 'ROOM',
  MEETING_SET = 'MEETING_SET'
}

export enum MEETING_TYPES_NAMES {
  TOHAINA = 'tohaina',
  ETHERPAD = 'sharedDocument',
  WHITEBOARD = 'whiteboard',
  PRESENT = 'present',
  SHEET = 'sheet',
  SLIDE = 'slide',
  COURSE_VIEWER = 'courseViewer',
}

export enum MEETING_TYPES_VALUES {
  TOHAINA = 'TOHAINA',
  EDUACPAD = 'PAD',
  WHITEBOARD = 'BOARD',
  PRESENTATION_MODE = 'PRESENTATION',
  SHEET = 'SHEET',
  SLIDE = 'SLIDE'
}

export enum API_VARIABLES {
  MEETING_ID = '{meetingId}',
  STUDENT_ID = '{personId}',
  CLASS_ID = '{classId}',
  SERVICE = '{service}',
  USER    = '{user}',
  SECTION_ID = '{sectionId}'
}

export enum MEETING_STORE_ACTION{
  ADD = 'ADD',
  CHANGE = 'CHANGE',
  DELETE = 'DELETE'
}

export const ACTIONS = {
  GET_SETS_A:'getSetsA',
  UPDATE_SET_A:'updateSetA',
  UPDATE_GROUP_A:'updateGroupA',
  UPDATE_STUDENT_A:'updateStudentA',
  OBTAIN_MEETING_USERS: 'obtainMeetingUsers',
  FETCH_LIVE_MEETINGS: 'fetchLiveMeetings',
  GET_ALL_ROOM_CLASSES_A: 'getAllRoomClassesA',
}

export const MUTATIONS = {
  SET_SETS_M: 'setSetsM',
  SET_CURRENT_CLASS_M:'setCurrentClassM',
  UPDATE_SET_M:'updateSetM',
  UPDATE_GROUP_M:'updateGroupM',
  UPDATE_STUDENT_M:'updateStudentM',
  UPDATE_MEETING_PAGE: 'updateMeetingPage',
  UPDATE_CURRENT_CALLS: 'updateCurrentCalls',
  SET_CURRENT_CALLS: 'setCurrentCalls',
  SET_MEETING_SESSION_ID: 'setMeetingSessionId',
  SET_EDUPAD_DOCUMENT: 'setEducpadDocumentId',
  ADD_PRESENTATION_MODE_MEETING: 'addPresentationModeMeeting',
  REMOVE_PRESENTATION_MODE_MEETING: 'removePresentationModeMeeting',
  UPDATE_INITIAL_PRESENTATION_MODE_MESSAGE: 'updateInitialPresentationModeMessage',
  UPDATE_CURRENT_MEETING_DATA: 'updateCurrentMeetingData',
  SET_MEETINGS_CLASSES: 'setMeetingsClasses',
  UPDATE_PRESENTATION_MODE_VIEWER_TYPE: 'updatePresentationModeViewerType',
  UPDATE_MULTIPLE_PRESENTATION_MODE_VIEWER_TYPES: 'updateMultiplePresentationModeViewerTypes',
  CLEAN_MEETING_PAGE: 'cleanMeetingPage',
  UPDATE_TRANSPARENT_BOARD_PATH: 'updateTransparentBoardPath',
  UPDATE_PRESENTATION_MODE_PAGE_INFO: 'updatePresentationModePageSizeInfo',
  UPDATE_WHITEBOARD_TRANSPARENCY: 'updateWhiteboardTransparency',
  UPDATE_INITIAL_WHITEBOARD_TRANSPARENCY: 'updateInitialWhiteboardTransparency',
  UPDATE_CURRENT_PRESENTATION_SECTION: 'updateCurrentPresentationSection',
  SET_MAIN_MEETING_TYPE: 'setMainMeetingType',
  UPDATE_CURRENT_PAGE_SIZES: 'updateCurrentPageSizes',
  ADD_CURRENT_PAGE_SIZES: 'addCurrentPageSizes',
  UPDATE_CURRENT_MEETING_USERS: 'updateCurrentMeetingUsers',
  UPDATE_CURRENT_BOARD_USER: 'updateCurrentBoardUser',
  ADD_CURRENT_MEETING_ACTIVE_USER: 'addCurrentMeetingActiveUser',
  REMOVE_CURRENT_MEETING_ACTIVE_USER: 'removeCurrentMeetingActiveUser',
  UPDATE_IS_TRANSPARENCY_MANUALLY: 'updateIsTransparencyManually',
  REMOVE_CURRENT_MEETING_USERS: 'removeCurrentMeetingUsers',
  CLEAR_CURRENT_MEETING_ACTIVE_USERS: 'clearCurrentMeetingActiveUsers',
  UPDATE_PRESENTATION_NAVIGATION: 'updatePresentationNavigation',
  UPDATE_PRESENTATION_MODE_USER_FILTER: 'updatePresentationModeUserFilter',
  SET_SHARE_TASK_DATA: 'setShareTaskData',
  CLEAR_PRESENTATION_MODE_MEETINGS: 'clearPresentationModeMeetings',
  UPDATE_VALIDATE_PRESENTATION_SESSSION: 'updateValidatedPresentationModeSession',
  UPDATE_PRESENTATION_MODE_GUEST_TEACHER: 'updatePresentationModeGuestTeacher',
  UPDATE_ACTIVE_PRESENTER_TEACHER: 'updateActivePresenterTeacher',
  UPDATE_OTHER_SESSION: 'updateOtherSession',
  UPDATE_PRESENTER_TEACHER_INFORMATION: 'updatePresenterTeacherInformation',
  UPDATE_SHOWING_CHANGE_PRESENTER: 'updateShowingChangePresenter',
  UPDATE_PRESENTATION_MODE_SCROLL_INFO: 'updatePresentationModeScrollInfo',
  UPDATE_PRESENTATION_MODE_LAYOUT_INFO: 'updatePresentationModeLayoutInfo',
  UPDATE_ORIGINAL_PAGES_SIZE: 'updateOriginalPagesSize',
  CLEAN_ORIGINAL_PAGES_SIZE: 'cleanOriginalPagesSize',
  UPDATE_LOADED_BOARDS_IN_DOM: 'updateLoadedBoardsInDom',
  UPDATE_INITIAL_BOARDS_LOADED_EMITED: 'updateInitialLoadedBoardsEmited',
  UPDATE_LAST_TEXT_MESSAGE: 'updateLastTextMessage',
  SET_ALL_ROOM_CLASSES: 'setAllRoomClassesM',
  UPDATE_CLASS_NAME_M: 'updateClassNameM'
}

export const _MEETINGS_STORE = {
  NAME: MEETINGS_STORE_NAME,
  MUTATIONS: {
    SET_SETS_M: `${MEETINGS_STORE_NAME}/${MUTATIONS.SET_SETS_M}`,
    SET_CURRENT_CLASS_M: `${MEETINGS_STORE_NAME}/${MUTATIONS.SET_CURRENT_CLASS_M}`,
    UPDATE_SET_M: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_SET_M}`,
    UPDATE_GROUP_M: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_GROUP_M}`,
    UPDATE_STUDENT_M: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_STUDENT_M}`,
    UPDATE_MEETING_PAGE: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_MEETING_PAGE}`,
    UPDATE_CURRENT_CALLS: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_CURRENT_CALLS}`,
    SET_CURRENT_CALLS: `${MEETINGS_STORE_NAME}/${MUTATIONS.SET_CURRENT_CALLS}`,
    SET_MEETING_SESSION_ID: `${MEETINGS_STORE_NAME}/${MUTATIONS.SET_MEETING_SESSION_ID}`,
    SET_EDUPAD_DOCUMENT: `${MEETINGS_STORE_NAME}/${MUTATIONS.SET_EDUPAD_DOCUMENT}`,
    ADD_PRESENTATION_MODE_MEETING: `${MEETINGS_STORE_NAME}/${MUTATIONS.ADD_PRESENTATION_MODE_MEETING}`,
    REMOVE_PRESENTATION_MODE_MEETING: `${MEETINGS_STORE_NAME}/${MUTATIONS.REMOVE_PRESENTATION_MODE_MEETING}`,
    UPDATE_INITIAL_PRESENTATION_MODE_MESSAGE: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_INITIAL_PRESENTATION_MODE_MESSAGE}`,
    UPDATE_CURRENT_MEETING_DATA: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_CURRENT_MEETING_DATA}`,
    SET_MEETINGS_CLASSES: `${MEETINGS_STORE_NAME}/${MUTATIONS.SET_MEETINGS_CLASSES}`,
    UPDATE_PRESENTATION_MODE_VIEWER_TYPE: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_PRESENTATION_MODE_VIEWER_TYPE}`,
    UPDATE_MULTIPLE_PRESENTATION_MODE_VIEWER_TYPES: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_MULTIPLE_PRESENTATION_MODE_VIEWER_TYPES}`,
    CLEAN_MEETING_PAGE: `${MEETINGS_STORE_NAME}/${MUTATIONS.CLEAN_MEETING_PAGE}`,
    UPDATE_TRANSPARENT_BOARD_PATH: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_TRANSPARENT_BOARD_PATH}`,
    UPDATE_PRESENTATION_MODE_PAGE_INFO: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_PRESENTATION_MODE_PAGE_INFO}`,
    UPDATE_WHITEBOARD_TRANSPARENCY: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_WHITEBOARD_TRANSPARENCY}`,
    UPDATE_INITIAL_WHITEBOARD_TRANSPARENCY: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_INITIAL_WHITEBOARD_TRANSPARENCY}`,
    UPDATE_CURRENT_PRESENTATION_SECTION: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_CURRENT_PRESENTATION_SECTION}`,
    SET_MAIN_MEETING_TYPE: `${MEETINGS_STORE_NAME}/${MUTATIONS.SET_MAIN_MEETING_TYPE}`,
    UPDATE_CURRENT_PAGE_SIZES: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_CURRENT_PAGE_SIZES}`,
    ADD_CURRENT_PAGE_SIZES: `${MEETINGS_STORE_NAME}/${MUTATIONS.ADD_CURRENT_PAGE_SIZES}`,
    UPDATE_CURRENT_MEETING_USERS: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_CURRENT_MEETING_USERS}`,
    UPDATE_CURRENT_BOARD_USER: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_CURRENT_BOARD_USER}`,
    ADD_CURRENT_MEETING_ACTIVE_USER: `${MEETINGS_STORE_NAME}/${MUTATIONS.ADD_CURRENT_MEETING_ACTIVE_USER}`,
    REMOVE_CURRENT_MEETING_ACTIVE_USER: `${MEETINGS_STORE_NAME}/${MUTATIONS.REMOVE_CURRENT_MEETING_ACTIVE_USER}`,
    UPDATE_IS_TRANSPARENCY_MANUALLY: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_IS_TRANSPARENCY_MANUALLY}`,
    REMOVE_CURRENT_MEETING_USERS: `${MEETINGS_STORE_NAME}/${MUTATIONS.REMOVE_CURRENT_MEETING_USERS}`,
    CLEAR_CURRENT_MEETING_ACTIVE_USERS: `${MEETINGS_STORE_NAME}/${MUTATIONS.CLEAR_CURRENT_MEETING_ACTIVE_USERS}`,
    UPDATE_PRESENTATION_NAVIGATION: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_PRESENTATION_NAVIGATION}`,
    UPDATE_PRESENTATION_MODE_USER_FILTER: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_PRESENTATION_MODE_USER_FILTER}`,
    SET_SHARE_TASK_DATA: `${MEETINGS_STORE_NAME}/${MUTATIONS.SET_SHARE_TASK_DATA}`,
    CLEAR_PRESENTATION_MODE_MEETINGS: `${MEETINGS_STORE_NAME}/${MUTATIONS.CLEAR_PRESENTATION_MODE_MEETINGS}`,
    UPDATE_VALIDATE_PRESENTATION_SESSSION: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_VALIDATE_PRESENTATION_SESSSION}`,
    UPDATE_PRESENTATION_MODE_GUEST_TEACHER: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_PRESENTATION_MODE_GUEST_TEACHER}`,
    UPDATE_ACTIVE_PRESENTER_TEACHER: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_ACTIVE_PRESENTER_TEACHER}`,
    UPDATE_OTHER_SESSION: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_OTHER_SESSION}`,
    UPDATE_PRESENTER_TEACHER_INFORMATION: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_PRESENTER_TEACHER_INFORMATION}`,
    UPDATE_SHOWING_CHANGE_PRESENTER: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_SHOWING_CHANGE_PRESENTER}`,
    UPDATE_PRESENTATION_MODE_SCROLL_INFO: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_PRESENTATION_MODE_SCROLL_INFO}`,
    UPDATE_PRESENTATION_MODE_LAYOUT_INFO: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_PRESENTATION_MODE_LAYOUT_INFO}`,
    UPDATE_ORIGINAL_PAGES_SIZE: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_ORIGINAL_PAGES_SIZE}`,
    CLEAN_ORIGINAL_PAGES_SIZE: `${MEETINGS_STORE_NAME}/${MUTATIONS.CLEAN_ORIGINAL_PAGES_SIZE}`,
    UPDATE_LOADED_BOARDS_IN_DOM: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_LOADED_BOARDS_IN_DOM}`,
    UPDATE_INITIAL_BOARDS_LOADED_EMITED: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_INITIAL_BOARDS_LOADED_EMITED}`,
    UPDATE_LAST_TEXT_MESSAGE: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_LAST_TEXT_MESSAGE}`,
    SET_ALL_ROOM_CLASSES: `${MEETINGS_STORE_NAME}/${MUTATIONS.SET_ALL_ROOM_CLASSES}`,
    UPDATE_CLASS_NAME_M: `${MEETINGS_STORE_NAME}/${MUTATIONS.UPDATE_CLASS_NAME_M}`,
  },
  ACTIONS: {
    GET_SETS_A: `${MEETINGS_STORE_NAME}/${ACTIONS.GET_SETS_A}`,
    UPDATE_SET_A: `${MEETINGS_STORE_NAME}/${ACTIONS.UPDATE_SET_A}`,
    UPDATE_GROUP_A: `${MEETINGS_STORE_NAME}/${ACTIONS.UPDATE_GROUP_A}`,
    UPDATE_STUDENT_A: `${MEETINGS_STORE_NAME}/${ACTIONS.UPDATE_STUDENT_A}`,
    OBTAIN_MEETING_USERS: `${MEETINGS_STORE_NAME}/${ACTIONS.OBTAIN_MEETING_USERS}`,
    FETCH_LIVE_MEETINGS: `${MEETINGS_STORE_NAME}/${ACTIONS.FETCH_LIVE_MEETINGS}`,
    GET_ALL_ROOM_CLASSES_A: `${MEETINGS_STORE_NAME}/${ACTIONS.GET_ALL_ROOM_CLASSES_A}`
  }
}

export const MEETINGS_API = {
  CREATE_OR_UPDATE_MEETING: 'meeting',
  CREATE_SET: 'meeting/set',
  UPDATE_SET: 'meeting/set/{meetingId}',
  DELETE_MEETING_OR_SET: 'meeting/{meetingId}',
  GET_MEETING_INFO: 'meeting/{meetingId}',
  GET_MEETINGS_FROM_CLASS: 'meeting/byClass/{classId}',
  GET_MEETING_STUDENTS_LIST: 'meeting/{meetingId}/students',
  ADD_OR_REMOVE_STUDENT_FROM_MEETING: 'meeting/{meetingId}/student/{personId}',
  GET_SPECIFIC_SERVICE: 'meeting/{meetingId}/join/{service}',
  GET_ALL_SERVICES: 'meeting/{meetingId}/join',
  GET_MEETING_ATENDEES: 'meeting/{meetingId}/attendees',
  GET_ALL_USER_MEETINGS_PUBLISHER: 'meeting/publisher',
  GET_ALL_USER_MEETINGS_VIEWER: 'meeting/viewer ',
  GET_USER_CLASS_ROOMS: 'meeting/myClassRooms',
  PRESENTATION_MODE_MEETING_INFORMATION: 'presentation-mode/meetings/{meetingId}',
  VALIDATE_PRESENTATION_MODE_SESSION: 'presentation-mode/meetings/{meetingId}/user-connection-status',
  OBTAIN_TRANSPARENCY_BOARD_ANNOTATIONS: 'meeting/board/{boardGroup}/annotations',
  SET_PRESENTATION_MODE_HOMEWORK_TEXT: 'presentation-mode/text',
  GET_PRESENTATION_MODE_HOMEWORK_TEXT: 'presentation-mode/text?classId={classId}&sectionId={sectionId}',
  DELETE_PRESENTATION_MODE_HOMEWORK_TEXT: 'presentation-mode/text?classId={classId}&sectionId={sectionId}',
  GET_PRESENTATION_MODE_STATUS: 'presentation-mode/status?meetingId={meetingId}'
}

export const MEETING_SHORT_NAV = [
  {
    name: 'courseViewer',
    active: false,
    id: -4,
    isInternal: true,
    icon: 'chalkboard-teacher',
    path: '#'
  },
  {
    name: 'whiteboard',
    active: false,
    id: -3,
    isInternal: true,
    icon: 'palette',
    path: '#'
  },
  {
    name: 'sharedDocument',
    active: false,
    id: -2,
    isInternal: true,
    icon: 'file-word',
    path: '#'
  },
  {
    name: 'sheet',
    active: false,
    id: -5,
    isInternal: true,
    icon: 'file-excel',
    path: '#'
  },
  {
    name: 'slide',
    active: false,
    id: -6,
    isInternal: true,
    icon: 'file-powerpoint',
    path: '#'
  }
]

export const EVENT_TYPES = {
  allMessages: 'AllMeetingMenuLocation',
  userData: 'UserData',
  shortMenu: 'ShortMenu',
  subscribe: 'Subscribe',
  studentToggle: 'StudentToggle',
  wboTransparentToggle: 'WboTransparentToggle'
}

export const SOCKET_EVENTS = {
  updateLocation: '/app/interactive/meetingsShortMenu.updateLocation',
  connect: '/app/interactive/meetingsShortMenu.connect',
  response: '/interactive/topic/'
}

export enum MEETING_TYPES_IDS {
  TOHAINA = -1,
  SHARED_DOC = -2,
  WHITEBOARD = -3,
  COURSE_VIEWER = -4,
  SHEET = -5,
  SLIDE = -6,
  PRESENTATION_MODE = -7
}

export const CRYPTPAD_MEETINGS = [
  MEETING_TYPES_IDS.SHEET,
  MEETING_TYPES_IDS.SLIDE,
  MEETING_TYPES_IDS.SHARED_DOC
];

export enum EDUPAD_COLLECTIONS {
  MEETINGS = 'meetings',
}

export const PRESENTATION_MODE_MEETING = -7;
